/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReplace = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 22h8v-8H2zm2-6h4v4H4zm15 1h-2.6l1.3-1.3-1.4-1.4-3.7 3.7 3.7 3.7 1.4-1.4-1.3-1.3H21v-6h-2zM14 2v8h8V2zm6 6h-4V4h4zM5 8.6 3.7 7.3 2.3 8.7 6 12.4l3.7-3.7-1.4-1.4L7 8.6V6h4V4H5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgReplace as Replace };
